export default {
  'nav.home': '首页',
  'nav.datasets': '数据集',
  'nav.docs': '文档',
  'nav.dataPrepare': '数据准备',
  'nav.dataUpload': '数据上传',
  'nav.material': '知识库',
  'nav.field': '自定义字段',
  'nav.source': '来源配置',
  'nav.OpenSourceTools': '开源工具',
  'nav.dynamics': '动态',
  'nav.aboutUs': '关于我们',

  'dataProcessing.title': '数据处理步骤',
  'dataProcessing.extraction': '数据提取',
  'dataProcessing.labeling': '数据标注',
  'dataProcessing.qualityAssessment': '数据质量评估',
  'dataProcessing.cleaning': '数据清洗',
  'dataProcessing.visualization': '数据可视化和分析',
  'dataProcessing.comingSoon': '敬请期待'
};
